import { SxProps, Theme } from '@mui/material'

/** Match DateRangePicker / toolbar row: 32px height, same typography */
export const chartToolbarButtonGroupSx: SxProps<Theme> = {
  mr: 1,
  '& .MuiButton-root': {
    minHeight: 32,
    maxHeight: 32,
    py: 0,
    px: 1.5,
    fontSize: '0.8125rem',
    fontWeight: 500,
    lineHeight: 1.2,
    boxSizing: 'border-box',
  },
}
